import type * as React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { faMotorcycle, faTruckMoving } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classnames from "classnames";

import type { Vtype } from "shared/dist/types/vehicle";

import { AppsWidget } from "@/components/AppsWidget";

import { PATH } from "./StatsSelector";

export const TabsBrands = (): React.ReactElement => {
    const { vtype = "vl" } = useParams<{ vtype: Vtype }>();
    const activeTab = vtype === "classic-motos" ? "classic" : vtype;
    const { t } = useTranslation();

    return (
        <>
            <div>
                <span> {t("carselector.select-make")} </span>
                <Nav tabs style={{ display: "inline-flex" }}>
                    <NavItem>
                        <Link to={`${PATH}/vl`}>
                            <NavLink
                                className={classnames({
                                    active: activeTab === "vl",
                                })}
                                tag="div"
                            >
                                <FontAwesomeIcon icon="car" />
                            </NavLink>
                        </Link>
                    </NavItem>
                    <NavItem>
                        <Link to={`${PATH}/motos`}>
                            <NavLink
                                className={classnames({
                                    active: activeTab === "motos",
                                })}
                                tag="div"
                            >
                                <FontAwesomeIcon icon={faMotorcycle} />
                            </NavLink>
                        </Link>
                    </NavItem>
                    <NavItem>
                        <Link to={`${PATH}/pl`}>
                            <NavLink
                                className={classnames({
                                    active: activeTab === "pl",
                                })}
                                tag="div"
                            >
                                <FontAwesomeIcon icon={faTruckMoving} />
                            </NavLink>
                        </Link>
                    </NavItem>
                </Nav>
            </div>
            <TabContent activeTab={activeTab} className="tabs-brands">
                <TabPane tabId="vl">
                    <AppsWidget widget="stats-selector-cars" />
                </TabPane>
                <TabPane tabId="pl">
                    <AppsWidget widget="stats-selector-trucks" />
                </TabPane>
                <TabPane tabId="motos">
                    <AppsWidget widget="stats-selector-motos" />
                </TabPane>
            </TabContent>
        </>
    );
};
